import { Controller } from "@hotwired/stimulus"

// « Nouvelle génération »: only the fields the chosen document and audience use.
export default class extends Controller {
  static targets = ["kind", "field"]

  connect() {
    this.refresh()
  }

  refresh() {
    const kind = this.kindTarget.value
    const audience = this.element.querySelector('input[name="audience"]:checked')?.value
    this.fieldTargets.forEach((field) => {
      const kinds = field.dataset.kinds?.split(" ")
      const hiddenKinds = field.dataset.exceptKinds?.split(" ")
      const audiences = field.dataset.audiences?.split(" ")
      field.hidden = Boolean((kinds && !kinds.includes(kind)) || hiddenKinds?.includes(kind) || (audiences && !audiences.includes(audience)))
    })
  }
}
